import SafetyMeasures from './SafetyMeasures';

export default SafetyMeasures;
